import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

export const SubtitleText = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: 'clamp(0.5rem, 1.5vw, 1.5rem)',
  color: theme.palette.text.secondary,
}));
